
import React, { useState } from 'react'
import { fetchAuthSession } from 'aws-amplify/auth';
import { BedrockAgentRuntimeClient, InvokeAgentCommand } from "@aws-sdk/client-bedrock-agent-runtime"
import PutStories from '../MyLibrary/putStories';
import TextCorrection from './TextCorrection';


const GenerateInitialStory = async (setStories, stories, story, setClientSecret, productType) => {
    const session = await fetchAuthSession()
    // console.log(session)

    const bedrockClient = new BedrockAgentRuntimeClient({
        region: 'us-east-1',
        credentials: session.credentials
    });

    let prompt = "Make me a children's story.";

    if (story.characters !== "") {
        prompt += " About the following characters: " + story.characters + ".";
    }

    if (story.setting !== "") {
        prompt += " In the following setting: " + story.setting + ".";
    }


    if (story.details !== "") {
        prompt += " Weave in these details: " + story.details + ".";
    }

    prompt += "Write about 12 pages with only a few sentences per page. Return the response with pages seperated into the book object of the following JSON format: {id:" + story.id + ", description: str, setting: str, title: " + story.title + ", pages: [{text: str }]}. Ensure that format is JSON serializable."
    // console.log(prompt);


    const params = {
        sessionId: story.id,
        agentId: "9YDI2DNOUZ", // TODO: make .env
        agentAliasId: "SWUOH7GTDO",
        inputText: prompt
    }
    let completion = ""
    try {
        const command = new InvokeAgentCommand(params);
        const response = await bedrockClient.send(command);
        // console.log('Response from Bedrock agent:', response);

        /*     for await (const chunk of stream) {
                console.log(chunk)
            } */

        let decoder = new TextDecoder("utf-8")
        for await (const chunk of response.completion) {
            // console.log("chunk:", chunk)
            const text = decoder.decode(chunk.chunk.bytes)
            completion += text
            // console.log(text)
        }


        // const result = await getProperties({
        //     // `identityId` will provide the ID of the currently authenticated user
        //     path: ({ identityId }) => `private/${identityId}/stories/${story.id}.json`,
        // // });
        // console.log(result)
        const newStory = JSON.parse(completion)
        newStory.productType = productType;
        newStory.mods = 0;

        setStories([...stories, newStory])
        PutStories(story.id, JSON.stringify(newStory))
        localStorage.removeItem('story_time.json')
        setClientSecret(null)
        return completion
    } catch (error) {
        TextCorrection(setStories, stories, story, completion, setClientSecret, productType)
    }
};

export default GenerateInitialStory;